import { useGetAppAccessQuery, useGetAppAccessTypeQuery } from '@app/services';
import { AppProjectType, Errors, LLM_FRAMEWORKS, LinkStatus } from '@common';
import type { AIModelFramework } from '@common';
import { MPFallback } from '@components';
import AppAuthorization from './AppAuthorization';
import { AppError } from './AppError';
import AppOffline from './AppOffline';
import AppFrame from './AppFrame';
import ApiAppContent from './ApiAppContent';
import LlmAppContent from './LlmAppContent';
import useAppname from './useAppname';

export function AppContent() {
    const { appName } = useAppname();

    const { data, isError, error, refetch, isFetching } = useGetAppAccessQuery(appName, {
        skip: !appName,
    });

    const { isFetching: accessTypeFetching } = useGetAppAccessTypeQuery(appName, { skip: !appName });

    const showAuth = [Errors.appForbidden, Errors.passwordRequired, Errors.passwordIncorrect].includes(
        (error as any)?.data?.message
    );

    if (isFetching || accessTypeFetching) return <MPFallback />;

    if (showAuth) return <AppAuthorization refetch={refetch} />;

    if (isError) return <AppError />;

    // REST API apps get a dedicated API page instead of iframe
    if (data?.app?.appType === AppProjectType.REST_API) {
        const framework = data?.app?.aiModelProperties?.framework;
        if (framework && LLM_FRAMEWORKS.includes(framework as AIModelFramework)) {
            return <LlmAppContent app={data.app} linkStatus={data?.status} />;
        }
        return <ApiAppContent linkStatus={data?.status} />;
    }

    if (data?.status === LinkStatus.OFFLINE) return <AppOffline />;

    if (!data?.accessToken) return null;

    return (
        <AppFrame
            accessToken={data?.accessToken}
            path={data?.path}
        />
    );
}
